import { createHashRouter } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { GuestOnly, RequireAuth } from '@/components/auth/RequireAuth';
import { Login } from '@/pages/Login';
import { Overview } from '@/pages/Overview';
import { Devices } from '@/pages/Devices';
import { DeviceDetail } from '@/pages/DeviceDetail';
import { Sites } from '@/pages/Sites';
import { Clients } from '@/pages/Clients';
import { MapView } from '@/pages/MapView';
import { Alerts } from '@/pages/Alerts';
import { Automation } from '@/pages/Automation';
import { Scripts } from '@/pages/Scripts';
import { Patches } from '@/pages/Patches';
import { Software } from '@/pages/Software';
import { RemoteSessions } from '@/pages/RemoteSessions';
import { Jobs } from '@/pages/Jobs';
import { Reports } from '@/pages/Reports';
import { AuditLog } from '@/pages/AuditLog';
import { UsersRoles } from '@/pages/UsersRoles';
import { Settings } from '@/pages/Settings';
import { RemoteDesktop } from '@/pages/RemoteDesktop';
import { FileExplorer } from '@/pages/FileExplorer';
import { Terminal } from '@/pages/Terminal';

export const router = createHashRouter([
  { path: '/login', element: <GuestOnly><Login /></GuestOnly> },
  {
    path: '/',
    element: <RequireAuth><AppLayout /></RequireAuth>,
    children: [
      { index: true, element: <Overview /> },
      { path: 'devices', element: <Devices /> },
      { path: 'devices/:id', element: <DeviceDetail /> },
      { path: 'devices/:id/remote-desktop', element: <RemoteDesktop /> },
      { path: 'devices/:id/files', element: <FileExplorer /> },
      { path: 'devices/:id/powershell', element: <Terminal type="powershell" /> },
      { path: 'devices/:id/cmd', element: <Terminal type="cmd" /> },
      { path: 'sites', element: <Sites /> },
      { path: 'clients', element: <Clients /> },
      { path: 'map', element: <MapView /> },
      { path: 'alerts', element: <Alerts /> },
      { path: 'automation', element: <Automation /> },
      { path: 'scripts', element: <Scripts /> },
      { path: 'patches', element: <Patches /> },
      { path: 'software', element: <Software /> },
      { path: 'remote-sessions', element: <RemoteSessions /> },
      { path: 'jobs', element: <Jobs /> },
      { path: 'reports', element: <Reports /> },
      { path: 'audit-log', element: <AuditLog /> },
      { path: 'users', element: <UsersRoles /> },
      { path: 'settings', element: <Settings /> },
    ],
  },
]);
